// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/meeting/camera.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.meetingPageHeader_back_arrow {
    padding-top: 2px;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

.meetingPageHeader {
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-left: 9px;
    padding-right: 9px;
}

.meetingPageHeader_title {
    font-weight: 600;
    font-size: calc(24px * var(--fontScaler));
    line-height: 32px;
    color: #000000;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.meetingPageHeader_title_icon {
    width: 35px;
    height: 20px;
    flex-shrink: 0;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.meetingPageHeader_back{
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 19px;
    color: #808080;
    display: flex;
    align-items: center;
    gap: 8px;
}

.meetingPageHeader_back_button {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: calc(14px * var(--fontScaler));
    color: #808080;
    padding: 0;
    transition: color 0.2s ease;
}



.meetingPageHeader_back_text {
    font-weight: 400;
}


.meetingPageHeader_left {
    display: flex;
    flex-direction: column;
}

.meetingPageHeader_right {
    display: flex;
    align-items: center;
    width: 350px;
    flex-shrink: 0;
}

.meetingPageHeader_client {
    display: flex;
    align-items: center;
    gap: 16px;
}

.meetingPageHeader_client_avatar {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #f0f0f0;
}

.meetingPageHeader_client_info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.meetingPageHeader_client_name {
    font-weight: 400;
    font-size: calc(24px * var(--fontScaler));
    line-height: 33px;
    color: #08080A;
    margin-bottom: 4px;
}

.meetingPageHeader_view_profile_button {
    background: none;
    border: none;
    font-style: italic;
    font-weight: 400;
    font-size: calc(16px * var(--fontScaler));
    line-height: 24px;
    color: #8E9ABB;
    cursor: pointer;
    padding: 0;
    text-decoration: underline;
}

`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/meetingPageHeader/MeetingPageHeader.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,2FAA2F;AAC/F;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,yDAA8D;AAClE;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yCAAyC;IACzC,cAAc;IACd,UAAU;IACV,2BAA2B;AAC/B;;;;AAIA;IACI,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,UAAU;IACV,0BAA0B;AAC9B","sourcesContent":["\n.meetingPageHeader_back_arrow {\n    padding-top: 2px;\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);\n}\n\n.meetingPageHeader {\n    margin-bottom: 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding-left: 9px;\n    padding-right: 9px;\n}\n\n.meetingPageHeader_title {\n    font-weight: 600;\n    font-size: calc(24px * var(--fontScaler));\n    line-height: 32px;\n    color: #000000;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meetingPageHeader_title_icon {\n    width: 35px;\n    height: 20px;\n    flex-shrink: 0;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-image: url('../../../../assets/meeting/camera.svg');\n}\n\n.meetingPageHeader_back{\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 19px;\n    color: #808080;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meetingPageHeader_back_button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: calc(14px * var(--fontScaler));\n    color: #808080;\n    padding: 0;\n    transition: color 0.2s ease;\n}\n\n\n\n.meetingPageHeader_back_text {\n    font-weight: 400;\n}\n\n\n.meetingPageHeader_left {\n    display: flex;\n    flex-direction: column;\n}\n\n.meetingPageHeader_right {\n    display: flex;\n    align-items: center;\n    width: 350px;\n    flex-shrink: 0;\n}\n\n.meetingPageHeader_client {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.meetingPageHeader_client_avatar {\n    width: 66px;\n    height: 66px;\n    border-radius: 50%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-color: #f0f0f0;\n}\n\n.meetingPageHeader_client_info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.meetingPageHeader_client_name {\n    font-weight: 400;\n    font-size: calc(24px * var(--fontScaler));\n    line-height: 33px;\n    color: #08080A;\n    margin-bottom: 4px;\n}\n\n.meetingPageHeader_view_profile_button {\n    background: none;\n    border: none;\n    font-style: italic;\n    font-weight: 400;\n    font-size: calc(16px * var(--fontScaler));\n    line-height: 24px;\n    color: #8E9ABB;\n    cursor: pointer;\n    padding: 0;\n    text-decoration: underline;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
